module.exports = __webpack_public_path__ + "static/media/44.36462295.jpg";